export default "__VITE_ASSET__D9YvB8HE__"